import { connect, MapStateToProps } from 'react-redux';
import { getShopItemsStreamId } from '../../../../../streams/shop';
import { ShopItemType } from '../../../../../../types/shop';
import { AppState } from '../../../../../../types/store';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../../../selectors/users';
import { Props } from './PremiumFolderSlider';
import { getFoldersByIds } from '../../../../../selectors/folders';
import { GallectionType } from '../../../../../../types/gallection';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags';

type StateProps = Pick<
  Props,
  | 'streamId'
  | 'folders'
  | 'total'
  | 'isOwner'
  | 'username'
  | 'isPremiumFoldersFeatureOn'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const streamId = getShopItemsStreamId(ShopItemType.PREMIUM_FOLDERS);
  return {
    streamId,
    folders: getFoldersByIds(
      state,
      GallectionType.GALLERY,
      streamSelectors.getItems(state, streamId)
    ),
    total: streamSelectors.getTotal(state, streamId),
    isOwner: isCurrentUserProfileOwner(state),
    isPremiumFoldersFeatureOn: flagEnabled(state, 'premium_folders'),
    username: getProfileOwnerUser(state).username,
  };
};

export default connect(mapStateToProps);
